import styled, { css } from 'styled-components';
export const LoaderContainer = styled.div `
  pointer-events: none;
  position: absolute;
  top: var(--table-head-cell-height);
  height: calc(100% - var(--table-head-cell-height));
  left: 0;
  width: 100%;

  ${(props) => props.$loading &&
    css `
      pointer-events: all;
      backdrop-filter: blur(0.075rem);
    `};
`;
